const fallSystem = {
  emitters: [
    {
      id: 1,
      name: '',
      position: {
        type: 'vectorRange',
        value: [
          [-0.1, 0],
          [0.9, 0],
        ],
      },
      speed: {
        type: 'range',
        value: [0.5, 1.7],
      },
      rate: {
        type: 'float',
        value: 75,
      },
      particle: {
        shape: {
          type: 'string',
          value: 'image',
        },
        wobble: {
          type: 'range',
          value: [0, 10],
        },
        gravity: {
          type: 'float',
          value: 0.003,
        },
        image: {
          type: 'chooseString',
          value: [
            'https://sharefolio-public.s3.amazonaws.com/leaf-orange.png',
            'https://sharefolio-public.s3.amazonaws.com/leaf-brown.png',
            'https://sharefolio-public.s3.amazonaws.com/leaf-red.png',
            'https://sharefolio-public.s3.amazonaws.com/leaf-yellow.png',
          ],
        },
        scale: {
          type: 'range',
          value: [0.1, 0.4],
        },
        rotation: {
          type: 'range',
          value: [0, 6.283],
        },

        rotationRate: {
          type: 'range',
          value: [-0.01, 0.01],
        },
        drag: {
          type: 'vector',
          value: [0.1, 0],
        },
        color: {
          type: 'colorOverLife',
          value: [
            {
              keyframe: 0,
              value: [255, 255, 255, 0],
            },
            {
              keyframe: 5,
              value: [255, 255, 255, 1],
            },
            {
              keyframe: 95,
              value: [255, 255, 255, 1],
            },
            {
              keyframe: 100,
              value: [255, 255, 255, 0],
            },
          ],
        },
      },
    },
    {
      id: 2,
      name: '',
      position: {
        type: 'vectorRange',
        value: [
          [-0.2, 0.4],
          [0.05, 1],
        ],
      },
      speed: {
        type: 'range',
        value: [0.5, 1.7],
      },
      rate: {
        type: 'float',
        value: 75,
      },
      particle: {
        shape: {
          type: 'string',
          value: 'image',
        },
        wobble: {
          type: 'range',
          value: [0, 10],
        },
        gravity: {
          type: 'float',
          value: 0.003,
        },
        image: {
          type: 'chooseString',
          value: [
            'https://sharefolio-public.s3.amazonaws.com/leaf-orange.png',
            'https://sharefolio-public.s3.amazonaws.com/leaf-brown.png',
            'https://sharefolio-public.s3.amazonaws.com/leaf-red.png',
            'https://sharefolio-public.s3.amazonaws.com/leaf-yellow.png',
          ],
        },
        color: {
          type: 'colorOverLife',
          value: [
            {
              keyframe: 0,
              value: [255, 255, 255, 0],
            },
            {
              keyframe: 5,
              value: [255, 255, 255, 1],
            },
            {
              keyframe: 95,
              value: [255, 255, 255, 1],
            },
            {
              keyframe: 100,
              value: [255, 255, 255, 0],
            },
          ],
        },

        scale: {
          type: 'range',
          value: [0.1, 0.4],
        },
        rotation: {
          type: 'range',
          value: [0, 6.283],
        },
        rotationRate: {
          type: 'range',
          value: [-0.01, 0.01],
        },
        drag: {
          type: 'vector',
          value: [0.1, 0],
        },
      },
    },
    {
      id: 3,
      name: '',
      position: {
        type: 'vectorRange',
        value: [
          [0, 0.95],
          [1, 1.01],
        ],
      },
      speed: {
        type: 'float',
        value: 0,
      },
      rate: {
        type: 'float',
        value: 25,
      },
      particle: {
        shape: {
          type: 'string',
          value: 'image',
        },

        image: {
          type: 'chooseString',
          value: [
            'https://sharefolio-public.s3.amazonaws.com/leaf-orange.png',
            'https://sharefolio-public.s3.amazonaws.com/leaf-brown.png',
            'https://sharefolio-public.s3.amazonaws.com/leaf-red.png',
            'https://sharefolio-public.s3.amazonaws.com/leaf-yellow.png',
          ],
        },
        scale: {
          type: 'range',
          value: [0.1, 0.4],
        },
        rotation: {
          type: 'range',
          value: [-0.6, 0],
        },

        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        drag: {
          type: 'vector',
          value: [0.1, 0],
        },
        color: {
          type: 'colorOverLife',
          value: [
            {
              keyframe: 0,
              value: [255, 255, 255, 0],
            },
            {
              keyframe: 5,
              value: [255, 255, 255, 1],
            },
            {
              keyframe: 95,
              value: [255, 255, 255, 1],
            },
            {
              keyframe: 100,
              value: [255, 255, 255, 0],
            },
          ],
        },
      },
    },
    {
      id: 4,
      name: '',
      position: {
        type: 'vectorRange',
        value: [
          [0, 0.95],
          [1, 1.01],
        ],
      },
      speed: {
        type: 'float',
        value: 0,
      },
      rate: {
        type: 'float',
        value: 25,
      },
      particle: {
        shape: {
          type: 'string',
          value: 'image',
        },

        image: {
          type: 'chooseString',
          value: [
            'https://sharefolio-public.s3.amazonaws.com/leaf-orange.png',
            'https://sharefolio-public.s3.amazonaws.com/leaf-brown.png',
            'https://sharefolio-public.s3.amazonaws.com/leaf-red.png',
            'https://sharefolio-public.s3.amazonaws.com/leaf-yellow.png',
          ],
        },
        scale: {
          type: 'range',
          value: [0.1, 0.4],
        },
        rotation: {
          type: 'range',
          value: [-4.4, -3.7],
        },

        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        drag: {
          type: 'vector',
          value: [0.1, 0],
        },
        color: {
          type: 'colorOverLife',
          value: [
            {
              keyframe: 0,
              value: [255, 255, 255, 0],
            },
            {
              keyframe: 5,
              value: [255, 255, 255, 1],
            },
            {
              keyframe: 95,
              value: [255, 255, 255, 1],
            },
            {
              keyframe: 100,
              value: [255, 255, 255, 0],
            },
          ],
        },
      },
    },

    {
      id: 5,
      layer: {
        type: 'string',
        value: 'foreground',
      },
      position: {
        type: 'vectorRange',
        value: [
          [-0.2, 1.5],
          [1.2, 1.5],
        ],
      },
      angle: {
        type: 'float',
        value: -0.75,
      },
      speed: {
        type: 'range',
        value: [2, 3],
      },
      rate: {
        type: 'float',
        value: 15,
      },
      particle: {
        lifetime: {
          type: 'float',
          value: 2,
        },
        shape: {
          type: 'string',
          value: 'image',
        },
        scale: {
          type: 'range',
          value: [0.2, 0.4],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        gravity: {
          type: 'float',
          value: 0.005,
        },
        wobble: {
          type: 'float',
          value: 1,
        },
        rotation: {
          type: 'range',
          value: [0, 6.28],
        },
        rotationRate: {
          type: 'range',
          value: [-0.04, 0.04],
        },
        drag: {
          type: 'vector',
          value: [1, 1],
        },

        color: {
          type: 'colorOverLife',
          value: [
            {
              keyframe: 0,
              value: [255, 255, 255, 0],
            },
            {
              keyframe: 30,
              value: [255, 255, 255, 1],
            },
            {
              keyframe: 70,
              value: [255, 255, 255, 1],
            },
            {
              keyframe: 100,
              value: [255, 255, 255, 0],
            },
          ],
        },
        image: {
          type: 'chooseString',
          value: [
            'https://sharefolio-public.s3.amazonaws.com/leaf-orange.png',
            'https://sharefolio-public.s3.amazonaws.com/leaf-brown.png',
            'https://sharefolio-public.s3.amazonaws.com/leaf-red.png',
            'https://sharefolio-public.s3.amazonaws.com/leaf-yellow.png',
          ],
        },
      },
    },

    {
      id: 10,
      layer: {
        type: 'string',
        value: 'background',
      },
      position: {
        type: 'vectorRange',
        value: [
          [-0.1, 1.05],
          [1.2, 1.25],
        ],
      },
      angle: {
        type: 'float',
        value: -3.14,
      },
      speed: {
        type: 'float',
        value: 0,
      },
      rate: {
        type: 'float',
        value: 20,
      },
      particle: {
        lifetime: {
          type: 'float',
          value: 12,
        },
        shape: {
          type: 'string',
          value: 'circle',
        },

        gravity: {
          type: 'float',
          value: 0,
        },
        scale: {
          type: 'range',
          value: [40, 60],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        color: {
          type: 'colorOverLife',
          color: '#103110',
          value: [
            {
              keyframe: 0,
              value: [107, 75, 50, 0],
            },
            {
              keyframe: 40,
              value: [107, 75, 50, 0.1],
            },
            {
              keyframe: 60,
              value: [107, 75, 50, 0.1],
            },
            {
              keyframe: 100,
              value: [107, 75, 50, 0],
            },
          ],
        },
      },
    },
    {
      id: 11,
      layer: {
        type: 'string',
        value: 'background',
      },
      position: {
        type: 'vectorRange',
        value: [
          [0, 0.2],
          [1.2, 1.2],
        ],
      },
      angle: {
        type: 'float',
        value: -3.14,
      },
      speed: {
        type: 'float',
        value: 0.1,
      },
      rate: {
        type: 'float',
        value: 15,
      },
      particle: {
        lifetime: {
          type: 'float',
          value: 6,
        },
        shape: {
          type: 'string',
          value: 'circle',
        },

        gravity: {
          type: 'float',
          value: 0.00025,
        },
        scale: {
          type: 'range',
          value: [60, 120],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        color: {
          type: 'chooseColorOverLife',
          color: '#fac60d',
          value: [
            [
              {
                keyframe: 0,
                value: [107, 75, 50, 0],
              },
              {
                keyframe: 20,
                value: [107, 75, 50, 0.1],
              },
              {
                keyframe: 40,
                value: [107, 75, 50, 0.1],
              },
              {
                keyframe: 100,
                value: [107, 75, 50, 0],
              },
            ],
            [
              {
                keyframe: 0,
                value: [250, 198, 13, 0],
              },
              {
                keyframe: 20,
                value: [250, 198, 13, 0.1],
              },
              {
                keyframe: 40,
                value: [250, 198, 13, 0.1],
              },
              {
                keyframe: 100,
                value: [250, 198, 13, 0],
              },
            ],
            [
              {
                keyframe: 0,
                value: [182, 32, 28, 0],
              },
              {
                keyframe: 20,
                value: [182, 32, 28, 0.1],
              },
              {
                keyframe: 40,
                value: [182, 32, 28, 0.1],
              },
              {
                keyframe: 100,
                value: [182, 32, 28, 0],
              },
            ],
          ],
        },
      },
    },
  ],
  effects: [
    {
      type: 'time',
      emitters: [1, 2],
      energy: 'above',
      data: {
        amount: 2,
      },
    },
    {
      type: 'impulse',
      emitters: [1, 2, 5],
      energy: 'above',
      data: {
        direction: -1,
        amount: 0.01,
      },
    },
    {
      type: 'spawnOffset',
      emitters: [5, 6],
      energy: 'above',
      data: {
        amount: [0, -0.6],
      },
    },
  ],
}

export default fallSystem
